import type { FC } from "react";
import { ASSISTANT_AVATAR } from "@/theme/tokens";

const { ACCESSORY } = ASSISTANT_AVATAR;

/** Round frames over both eyes, drawn on the character's face grid. */
export const AvatarGlasses: FC = () => (
	<>
		<g fill={ACCESSORY.LENS} stroke={ACCESSORY.INK} strokeWidth={2.6}>
			<circle cx={46} cy={60} r={12} />
			<circle cx={74} cy={60} r={12} />
		</g>
		<path d="M58 59 Q60 56 62 59" fill="none" stroke={ACCESSORY.INK} strokeWidth={2.6} />
	</>
);
